import { BrandColors } from '../theme';

export const badgeTokens = {
    root: {
        borderRadius: '2rem',
        padding: '0 0.5rem',
        fontSize: '0.75rem',
    },
    primary: {
        background: BrandColors.primary[500],
        color: BrandColors.semantic.textInverse,
    },
    secondary: {
        background: BrandColors.surface[100],
        color: BrandColors.surface[600],
    },
    success: {
        background: BrandColors.green[100],
        color: BrandColors.green[800],
    },
    info: {
        background: BrandColors.primary[100],
        color: BrandColors.primary[900],
    },
    warn: {
        background: BrandColors.yellow[100],
        color: BrandColors.yellow[700],
    },
    danger: {
        background: BrandColors.red[100],
        color: BrandColors.red[900],
    },
};
